// extracted by mini-css-extract-plugin
module.exports = {"userLight":"_icons-module--user-light--3c2Za"};